import React from 'react';
import { Badge } from "../ui/badge";
import { Button } from "../ui/button";
import { FileText, Edit2 } from "lucide-react";
import { cn } from "../ui/utils";

export interface Form {
  id: string;
  name: string;
  description: string;
  status: 'Published' | 'Draft' | 'Retired' | 'PUBLISHED' | 'DRAFT' | 'RETIRED' | string;
}

interface FormCardProps {
  form: Form;
  onEdit?: (id: string) => void;
  onPreview?: (id: string) => void;
}

export const FormCard: React.FC<FormCardProps> = ({ form, onEdit, onPreview }) => {
  return (
    <div className="bg-white p-6 rounded-xl border border-gray-100 shadow-sm hover:shadow-md transition-all duration-200">
      <div className="flex justify-between items-start mb-4">
        <div className="p-2 bg-gray-50 rounded-lg">
          <FileText className="h-5 w-5 text-gray-400" />
        </div>
        <Badge 
          className={cn(
            "text-[10px] font-bold uppercase rounded-sm px-2 py-0.5 border-none",
            (form.status === 'Published' || form.status === 'PUBLISHED') ? "bg-green-100 text-green-700" : 
            (form.status === 'Draft' || form.status === 'DRAFT') ? "bg-gray-100 text-gray-500" : 
            "bg-gray-100 text-gray-500"
          )}
        >
          {form.status}
        </Badge>
      </div>

      <h3 className="text-lg font-bold text-gray-900 mb-1">{form.name}</h3>
      <p className="text-sm text-gray-500 mb-6 line-clamp-2 min-h-[40px]">{form.description}</p>

      <div className="flex items-center gap-3">
        <Button 
          className="flex-1 bg-black text-white hover:bg-black/90 h-10 font-semibold"
          onClick={() => onEdit?.(form.id)}
        >
          <Edit2 className="mr-2 h-4 w-4" /> Edit Form
        </Button>
        <Button 
          variant="outline" 
          className="flex-1 h-10 font-semibold border-gray-200 hover:bg-gray-50"
          onClick={() => onPreview?.(form.id)}
        >
          Preview
        </Button>
      </div>
    </div>
  );
};
